import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { CHECKOUT_URL, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
const INCLUDED = ['6 professional plant nutrition visual modules', '5 strategic professional bonuses', 'Nutrient deficiency identification charts', 'Toxicity and plant stress comparisons', 'Soil pH, EC, and nutrient availability references', 'Leaf tissue analysis interpretation guides', 'Crop-specific visual symptom galleries', 'Field inspection and nutrition assessment templates'];
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-white py-5 sm:py-7" data-id="element-117" data-mp="13yc8dkz06dq0">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-118" data-mp="ywwm5pl3a161">
        <p className="mx-auto w-fit rounded bg-gold px-3 py-1 font-display text-xs font-extrabold uppercase tracking-widest text-forest sm:text-sm" data-id="element-119" data-mp="2fc6asz4wdmn9">
          Special launch offer
        </p>

        <div className="mt-2 overflow-hidden rounded-xl border-[3px] border-dashed border-leaf bg-white" data-id="element-120" data-mp="2affss69j8gz7">
          <div className="bg-forest p-3 text-center sm:p-5" data-id="element-121" data-mp="ujbme4l4m4w3">
            <h2 className="text-2xl leading-none text-white sm:text-4xl" data-id="element-122" data-mp="uhqtejegmu0c">🌱 {PRODUCT}</h2>
            <p className="mx-auto mt-1 max-w-2xl font-display text-xs font-semibold uppercase leading-tight tracking-wide text-gold sm:text-base" data-id="element-123" data-mp="zjputnqn3gun">
              {PRODUCT_TAGLINE}
            </p>
          </div>

          <div className="grid gap-3 p-3 sm:p-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-6" data-id="element-124" data-mp="6vkcf7n263xz">
            <MockupImage data-id="element-125" data-mp="bt2a21vmkwqo" />

            <div data-id="element-126" data-mp="fufi8im6xc0r">
              <p className="font-display text-lg font-extrabold uppercase text-forest sm:text-xl" data-id="element-127" data-mp="ftw0p30gcpn9">
                Complete 6-in-1 Professional Visual System
              </p>
              <ul className="mt-1 grid gap-1" data-id="element-128" data-mp="3k8m0yu8tq32k">
                {INCLUDED.map(item => <li key={item} className="flex items-start gap-2" data-id="element-129" data-mp="3k6t3o5k3ov78">
                    <span className="leading-snug" aria-hidden="true" data-id="element-130" data-mp="3o8o65ddrpeml">
                      ✅
                    </span>
                    <span className="text-sm font-semibold leading-snug text-ink sm:text-base" data-id="element-131" data-mp="vdnvqlwexx86">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-3 rounded-lg border-2 border-gold bg-gold-soft px-3 py-2 text-center" data-id="element-132" data-mp="157d7vxbfz9uf">
                <p className="font-display text-sm font-extrabold uppercase leading-tight text-forest sm:text-lg" data-id="element-133" data-mp="cgv4swapx8h0">
                  🔥 GET {PRODUCT} TODAY —{' '}
                  <span className="whitespace-nowrap text-3xl text-leaf sm:text-4xl" data-id="element-134" data-mp="7jmjimu9wobj">$27 USD</span>
                </p>
              </div>

              <div className="mt-3 flex flex-col items-center" data-id="element-135" data-mp="hfzf5q9dpc8x">
                <CTAButton href={CHECKOUT_URL} data-id="element-136" data-mp="heo9fkwdhuf6">🌱 GET INSTANT ACCESS</CTAButton>
                <TrustLine items={['Immediate Digital Access', '🛡️ 7-Day Money-Back Guarantee']} data-id="element-137" data-mp="1wveuuqvpz1gw" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}